import styled from "@emotion/styled";
import { Form } from "antd";
import UploadImages from "../../UploadImages";
import { FC } from "react";
import { allowFileExtensionsImage } from "config";

interface CampaignSubImageCardProps {
  is_active: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
}

const CampaignSubImageCard: FC<CampaignSubImageCardProps> = ({ is_active, setCheckIsActive }) => {
  return (
    <>
      <UploadWrapper>
        <Form.Item
          label="รูปภาพเพิ่มเติม"
          name="sub_images"
          required
          rules={[
            {
              required: true,
              message: "กรุณาเพิ่มรูปภาพเพิ่มเติม",
            },
          ]}
        >
          <UploadImages maximumUploadItems={10} allowFileExtensions={allowFileExtensionsImage}/>
        </Form.Item>
      </UploadWrapper>
    </>
  );
};

export default CampaignSubImageCard;

const UploadWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 10px;
  background-color: #ffffff;
`;
